import AccountDeleteConfirm from "../components/account_manage/AccountDeleteConfirm";
import AccountList from "../components/account_manage/AccountList";
import SiteNotiEdit from "../components/SiteNotiEdit";
import StaffNavBar from "../components/StaffNavBar";
import Toast from "../components/Toast";

const AccountManage = () => {
  return (
    <>
      <Toast />
      <StaffNavBar />
      <AccountList />
      <AccountDeleteConfirm />
      <SiteNotiEdit />
    </>
  );
};

export default AccountManage;
